import { Translate } from '@chipinside/translate'
import { Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import { useState } from 'react'

type Props = {
  onProceed: () => void
}

export function BypassSection({ onProceed }: Props) {
  const [hasAcceptedRisk, setHasAcceptedRisk] = useState(false)

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        marginTop: 5,
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={hasAcceptedRisk}
            onChange={event => setHasAcceptedRisk(event.target.checked)}
          />
        }
        label={Translate({
          messageKey: 'browser_guard_confirm_checkbox',
        })}
      />

      <Button
        variant="soft"
        color="error"
        disabled={!hasAcceptedRisk}
        onClick={onProceed}
        sx={{
          alignSelf: { sm: 'flex-start' },
          px: 10,
        }}
      >
        {Translate({
          messageKey: 'browser_guard_proceed_button',
        })}
      </Button>
    </Box>
  )
}
